"use strict";

var _classCallCheck = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = exports.colorize = exports.colorOptions = void 0;

var colorette = require("colorette");

var colorette_1 = require("colorette");

Object.defineProperty(exports, "colorOptions", {
  enumerable: true,
  get: function get() {
    return colorette_1.options;
  }
});

var env_1 = require("./env");

var utils_1 = require("./utils");

exports.colorize = new Proxy(colorette, {
  get: function get(target, prop) {
    if (env_1.isBrowser) {
      return utils_1.identity;
    }

    return target[prop];
  }
});

var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, [{
    key: "stderr",
    value: function stderr(str) {
      return process.stderr.write(str);
    }
  }, {
    key: "info",
    value: function info(str) {
      return env_1.isBrowser ? console.log(str) : this.stderr(str);
    }
  }, {
    key: "warn",
    value: function warn(str) {
      return env_1.isBrowser ? console.warn(str) : this.stderr(exports.colorize.yellow(str));
    }
  }, {
    key: "error",
    value: function error(str) {
      return env_1.isBrowser ? console.error(str) : this.stderr(exports.colorize.red(str));
    }
  }]);

  return Logger;
}();

exports.logger = new Logger();